export default __webpack_public_path__ + "static/media/news45.05096e20.jpg";